<template>
  <el-container class="login" v-loading="loading">
    <el-aside width="50%"></el-aside>
    <el-main class="content">
      <div class="logo">
        <a href><img src="../../assets/img/logo.png" alt="LOGO" class="logo-img" /></a>
      </div>
      <el-form :model="login" v-if="page_level == 0" :rules="rules" ref="loginForm">
        <h2 class="form-title">
          ADVERTISER
          <br />
          LOGIN
        </h2>
        <el-form-item prop="username">
          <label class="ym-label">Email</label>
          <el-input
            class="login-input"
            type="text"
            autocomplete="off"
            v-model="login.username"
            name="username"
          ></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <label class="ym-label">Password</label>
          <el-input
            class="login-input"
            type="password"
            autocomplete="off"
            v-model="login.password"
            name="password"
            @keyup.native="$event.keyCode == 13 ? Login() : ''"
          ></el-input>
        </el-form-item>
        <el-form-item v-if="captcha_enable" prop="captcha">
          <el-input
            v-model="login.captcha"
            name="captcha"
            @keyup.native="$event.keyCode == 13 ? Login() : ''"
          ></el-input>
          <img
            class="captcha-img"
            @click="src = '/api/common/get-captcha/?' + Math.random()"
            :src="src"
            alt="captcha"
          />
        </el-form-item>
        <el-form-item>
          <el-checkbox id="remember" name="remember"></el-checkbox>
          <label class="ym-label">Remember me</label>
        </el-form-item>
        <el-form-item>
          <el-button class="login-btn" type="primary" @click="Login">Login</el-button>
        </el-form-item>
        <div class="forget-password" style="width:60%;">
          <p>
            Forgot password ?
            <a class="forget" @click="page_level = 101">click here !</a>
          </p>
        </div>
        <!-- <div class="create-account">
          <p class="create-tips">Don't have an account yet ?</p>
        </div> -->
      </el-form>
      <el-form v-if="page_level == 2" id="verify-form">
        <h3 class="form-section">Verify Your Mailbox Please!</h3>
        <div class="form-body">
          <div class="login-options">
            <p>
              <span>We have sent you an email.Please check your email and verify.</span>
            </p>
          </div>
        </div>
        <div class="form-actions">
          <el-button class="back-btn" @click="page_level = 0">Back</el-button>
        </div>
      </el-form>
      <el-form
        v-if="page_level == 101"
        :model="emailForm"
        ref="emailForm"
        :rules="emailRules"
        @submit.native.prevent
      >
        <h2 class="form-title">
          Forgot
          <br />
          Password ?
        </h2>
        <el-form-item prop="verify_email">
          <label class="ym-label">Enter your e-mail address below to reset your password.</label>
          <el-input
            class="email-forget"
            type="email"
            autocomplete="off"
            placeholder="Email"
            v-model="emailForm.verify_email"
            @keyup.native.stop="$event.keyCode == 13 ? onVerify('Attention') : ''"
          ></el-input>
        </el-form-item>
        <div class="form-actions">
          <div class="submit-btn">
            <el-button @click="onVerify('Attention')">
              Submit
            </el-button>
          </div>
          <div class="back-btn">
            <el-button @click="page_level = 0">
              Back
            </el-button>
          </div>
        </div>
      </el-form>
    </el-main>
    <el-dialog title="Attention" :visible.sync="dialogVisible" width="50%">
      <span>We have send you an email. Please check your mailbox.</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">OK</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
import { getCookie, setCookie, removeCookie } from 'tiny-cookie'

export default {
  data() {
    return {
      loading: false,
      src: '/api/common/get-captcha/',
      signAsRole: '',
      page_level: 0,
      login: {
        orgtype: 2,
      },
      captcha_enable: false,
      emailForm: {},
      dialogVisible: false,
      rules: {
        username: [{ required: true, message: 'Can\'t be empty!', trigger: 'blur' }],
        password: [{ required: true, message: 'Can\'t be empty!', trigger: 'blur' }],
        captcha: [{ validator: this.verifyCaptcha, trigger: ['blur'] }],
      },
      emailRules: {
        verify_email: [
          { required: true, message: 'Can\'t be empty!', trigger: ['blur'] },
          { type: 'email', message: 'Please enter the correct email', trigger: ['blur'] },
        ],
      },
    }
  },
  created() {
    if (window.location.search) {
      let next = window.location.search.split('?')[1].split('=')[1]
      if (next.indexOf('mobile') >= 0) {
        // 移动端登录
        removeCookie('login')
      }
    }

    let location_params = this.$route.query
    if (location_params.id) {
      if (getCookie('login')) {
        this.aderLogout()
      }
      setCookie('source', location_params.source)
      setCookie('am_id', location_params.id)
      //   this.signAs('aff');
    }
    if (getCookie('login')) {
      this.routerChange('home')
    }
  },
  methods: {
    Login() {
      this.$refs['loginForm'].validate(valid => {
        if (valid) {
          this.loading = true
          this.$http
            .post('/accounts/login-r/', this.login)
            .then(() => {
              this.loading = false
              setCookie('login', true)
              let next = ''

              if (window.location.search) {
                next = window.location.search.split('?')[1].split('=')[1]
                next = next.replace(/%2F/g, '/')
              }
              removeCookie('source')
              removeCookie('am_id')
              if (next === 'mobile') {
                location.href = '/mobile/'
              } else if (next) {
                location.href = '' + next
              } else {
                this.routerChange('snapshot')
              }
            })
            .catch(err => {
              this.loading = false
              let captcha = document.getElementsByClassName('captcha-img')[0]
              if (captcha) {
                captcha.src = '/api/common/get-captcha/'
                this.captcha_status = false
              }
              switch (err.c) {
                case -1006: // verify
                  this.page_level = 2
                  this.$http.get('/accounts/verify-send-r/', {
                    params: {
                      email: this.login.username,
                    },
                  })
                  break
                case -1011: // pending,page_level = 3
                  this.routerChange('user-verify', { verify: 1 })
                  break
                case -1031: // captcha error
                  this.captcha_enable = true
                  this.notifyOpen('Error', this.executeError(err), 'error')
                  break
                default:
                  // network error
                  this.notifyOpen('Error', this.executeError(err), 'error')
              }
            })
        }
      })
    },

    verifyCaptcha(rule, value, callback) {
      let item = {}
      if (this.page_level === 0) {
        item.captcha = this.login.captcha
      }
      this.$http
        .post('/api/common/check-captcha/', item)
        .then(() => {
          callback()
        })
        .catch(() => {
          callback(new Error('wrong captcha'))
        })
    },
    onVerify(label) {
      let url, email
      let verify = true
      if (label === 'Success') {
        url = '/accounts/verify-send-again-r/'
        email = ''
      } else {
        url = '/accounts/forget/'
        email = this.emailForm.verify_email
        this.$refs['emailForm'].validate(valid => {
          if (!valid) {
            verify = false
          }
        })
      }

      if (!verify) {
        return
      }

      this.$http
        .post(url, { email: email })
        .then(() => {
          this.dialogVisible = true
        })
        .catch(err => {
          this.notifyOpen('Error', this.executeError(err), 'error')
        })
    },
  },
}
</script>

<style scoped lang="scss">
#remember {
  margin-right: 12px;
}
.forget {
  cursor: pointer;
  color: #0080cc;
}
.login {
  min-height: 100%;
  background: url(../../assets/img/bg.jpg) no-repeat;
  background-size: cover;
  position: relative;
  display: flex;
  .captcha-img {
    margin-top: 10px;
  }
  .el-aside {
    background: transparent;
  }
  .logo {
    margin: 35px 0 0 6%;
  }
  .content {
    background-color: rgba(255, 255, 255, 0.8);
    margin-bottom: 0px;
    padding: 30px;
    padding-top: 20px;
    padding-bottom: 15px;
    position: relative;
    z-index: 1;
    .form-title {
      font-weight: 700;
      font-size: 30px;
      line-height: 1.1;
      color: #333;
      margin: 6% 0 8%;
    }
    .create-account {
      width: 60%;
      border-top: 2px dotted #999;
      padding-top: 20px;
      margin-top: 20px;
    }
    &:before {
      content: ' ';
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      background: url(../../assets/img/blur.png) no-repeat;
      background-size: cover;
      z-index: -1;
    }
    .forget-password p {
      color: #999;
      font-size: 17px;
    }
    .create-account .create-tips {
      font-size: 20px;
      color: #999;
    }
    .create-account a {
      display: inline-block;
      margin-top: 5px;
      color: #0080cc;
      font-size: 20px;
    }
  }
  .login-btn {
    width: 60%;
    border-radius: 40px;
    background-color: #0080cc;
    color: #fff;
    font-size: 18px;
    font-weight: 700;
    border-style: none;
    line-height: 50px;
  }
  #verify-form {
    padding-left: 6%;
    h3 {
      color: #000;
      font-size: 24px;
      margin-top: 20px;
      margin-bottom: 10px;
      font-weight: 500;
      line-height: 1.1;
    }
    .form-body {
      padding-top: 10px;
      font-size: 14px;
      color: #333;
    }
    .back-btn {
      margin-top: 10px;
      width: 80px;
      height: 30px;
      background-color: #bbb;
      color: #fff;
      padding: 6px 12px;
      margin-bottom: 0;
      font-size: 14px;
      font-weight: 400;
    }
  }
}

.el-form {
  padding-left: 10%;
}
.el-input {
  display: block;
  width: 60%;
}
.ym-label {
  font-size: 16px;
  color: #999;
}
.submit-btn,
.back-btn {
  .el-button {
    margin-top: 30px;
    padding: 6px 12px;
    width: 400px;
    border-radius: 40px;
    background-color: #0080cc;
    line-height: 40px;
    font-size: 18px;
    color: #fff;
  }
}
.back-btn {
  .el-button {
    background-color: #bbb;
  }
}
.email-forget {
  height: 50px;
  width: 400px;
}
</style>
